<template>
  <div>
    <h6 class="login-header">About</h6>
    <div class="about-container">
      <div class="about-logo">
        <img src="@/assets/icons/Logo_sdg1.svg" alt="logo"/>
        <p>1.0.0</p>
        <!-- <p>{{AppConfig.appversion.WEB}}</p> -->
      </div>
      <div class="about-text">
        <p class="text-style">
          {{AppConfig.about.abouttext}}
        </p>
      </div>
      <div class="support-text">
        <p>
          <a :href="AppConfig.about.website"
          target="_blank" rel="noopener" aria-label="Web link" class="text-style">
          {{AppConfig.about.website}}
          </a>
        </p>
      </div>
      <div class="about-social-icons">
        <p class="text-style boldStyle">Follow Us</p>
        <a
        :href="AppConfig.about.social.facebook"
        target="_blank" rel="noopener" aria-label="facebook link">
            <img src="@/assets/icons/fb@2x.svg" alt="facebook logo"/>
        </a>
        <a
        :href="AppConfig.about.social.instagram"
        target="_blank" rel="noopener" aria-label="facebook link">
            <img src="@/assets/icons/Ic_insta@2x.svg" alt="instagram logo"/>
        </a>
        <a
        :href="AppConfig.about.social.twitter"
        target="_blank" rel="noopener" aria-label="twitter link">
            <img src="@/assets/icons/twitter_2x.svg" alt="twitter logo"/>
        </a>
        <a
        :href="AppConfig.about.social.youtube"
        target="_blank" rel="noopener" aria-label="youtube link">
            <img src="@/assets/icons/Ic_youtube.svg" alt="youtube logo"/>
        </a>
        <a
        :href="AppConfig.about.social.pinterest"
        target="_blank" rel="noopener" aria-label="pinterest link">
            <img src="@/assets/icons/Ic_pinterest.svg" alt="pinterest logo"/>
        </a>
      </div>
      <div class="about-links">
        <router-link :to="{ name: 'TermsOfUse' }">
          <span>terms of use</span>
        </router-link>
        <router-link :to="{ name: 'PrivacyPolicy' }">
          <span>privacy policy</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {

  computed: {
    ...mapGetters([
      'AppConfig'
    ])
  }
}
</script>

<style lang='scss' scoped>
@import '~sass/modules/variables';
.login-header{
  margin-top: 30px;
  text-align: center;
  width: 100%;
  float: left;
  font-style: normal;
  color: #212121;
  font-size: 24px;
  font-family: 'ProximanovaBold';
}
.text-style{
  color: #212121;	
  font-family: "ProximanovaRegular";		
  font-size: 16px;
}
.boldStyle{
  font-family: "ProximanovaBold";
}
.support-text{
  text-align: center;
}
.about-container{
  padding: 10%;
  .about-logo{
    text-align: center;
    padding-bottom: 5%;
    img {
      width: 15%;
      // margin: 2% 0;
    }
  }
  .about-text{
    padding-bottom: 5%;
    p{
      text-align: center;
    }
  }
  .about-links{
    text-align: center;
    :nth-child(1){
      margin-right: 25px;
    }
    span{
      color: #4558DD;	
      font-family: "ProximanovaRegular";		
      font-size: 14px;
      text-transform: uppercase;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .about-social-icons{
    text-align: center;
    padding: 5% 0;
    p{
      padding: 2%;
    }
    :nth-child(2){
      margin-left: 0px;
    }
    a{
      margin-left: 20px;
      opacity: 0.8;
      &:hover{
        opacity: 1;
      }
    }
    img{
      flex: 1;
      width: 25px;
      height: 25px;
      
      cursor: pointer;    
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/About/About.vue